<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="row" style="padding: 5px !important; width:100% !important;">
          <div class="col-auto" style="padding-right: 0 !important;">
            <div class="d-flex align-items-center">
              <h3 style="margin-bottom: 0 !important;">
                <span style="margin-left: 15px;"><fa-icon [icon]="['fas', 'eye']"> </fa-icon> Enterprise Observations </span>
              </h3>
            </div>
          </div>
          <div class="col pull-right">
            <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning"
                               (btnClicked)="openCompanyObservationsHelp()">
            </app-eca-ghost-btn>
          </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="container-fluid" style="margin-bottom: 50px; padding-right: 0; padding-left: 0;">
        <div *ngIf="observationsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!observationsLoading">
          <app-observations-list [observations]="companyObservations" [tableTitle]="'Enterprise Observations'" [showWarningMessage]="false" [showAddButton]="false"
                                 [allowedOperations]="loggedInUser?.observationOperations"
                                 [companyId]="loggedInUser?.companyId"
                                 (createObservationClicked)="createOrEditObservation($event,  true, 'Add Observation for ')"
                                 (editObservationClicked)="createOrEditObservation($event, true, 'Observation of ' )"></app-observations-list>

        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
